<template>
  <b-row>
    <b-col cols="12" md="7">
    <div
        :key="$store.getters['resource/currentResource'].key"
        class="white-container">
      <!--    <b-form-->
      <!--      novalidate-->
      <!--      ref="form"-->
      <!--      @submit.prevent="debounceSubmit"-->
      <!--      :validated="formValidated">-->
      <!--      <PartnerView-->
      <!--        v-if="fields"-->
      <!--        :columnWith="6"-->
      <!--        :submit="emitSubmitPartnerForm"-->
      <!--        :fields="fields.partner.items"-->
      <!--        @submit="createPartner"-->
      <!--      />-->
      <!--      <InviteView-->
      <!--        v-if="fields"-->
      <!--        :partner_id="partner_id"-->
      <!--        :columnWith="6"-->
      <!--        :fields="fields.invite.items"-->
      <!--      />-->
      <!--      <form-buttons></form-buttons>-->
      <!--    </b-form>-->
      <loader v-if="loading"/>
      <form-fields
          v-else
          @submit="createPartner"
          :formColumns="12"
          class="px-2"
          :fields="fields"
          :labelBlockWith="4"
          :mb="4"
      />
    </div>
    </b-col>
  </b-row>
</template>

<script>
  import fields from "./../partnersRegistration/partnerRegistrationFields"
  import PartnerView from './PartnerView';
  import InviteView from './InviteView';
  import FormFields from "../../components/global/formBuilder";
  import i18n from "../../utils/i18n";

  export default {
    name: 'PartnerCreation',
    middleware: ['auth'],
    components: {
      FormFields,
      PartnerView,
      InviteView
    },
    data() {
      return {
        fields: fields.partner.items,
        formValidated: false,
        emitSubmitPartnerForm: false,
        partner_id: null,
        loading: false
      }
    },
    mounted() {
      this.getPricingPlansOptions()
    },
    methods: {
      async createPartner (params) {
        this.loading = true
        await this.postData('partners', {
          ...params,
          pricing_plans_id: params.pricing_plan.id
        })
        .then(() => {
          this.$router.push('/partners')
        })
        .catch((error) => {
          console.log('create partner error', error)
        })
        this.loading = false
      },
      async getPricingPlansOptions () {
        this.loading = true
        await this.getData('pricing/plans')
        .then(({data}) => {
          this.fields.map(item => {
            if (item.label === i18n.t('login.wallkit_pricing_plan')) {
              item.options = data.items
            }
          })
        })
        .catch(error => {
          console.log('get pricing plans error', error)
        })
        this.loading = false
      }
    }
  }
</script>
